<template lang="pug">
  section(class="separable")
    div.marginTop(class="container")
      el-row
        el-col(:span="24")
          div(class="card")
            div(class="card-header").titulo Processos existentes
            div.marginDivider
              app-divider-refresh-button(
                :label="headerLabel",
                :hasButton="hasRefreshButton",
                :content="tooltipRefreshButton"
                :showBorder="false",
              )
            div(class="card-body")
              el-row
                .divider
              .table-pointer
                el-table(
                  :data='processos',
                  :default-sort = "{ prop: 'id', order: 'descending' }",
                  @sort-change="sort",
                )
                  template(slot="empty", v-if="!isBusca") Não há registros.
                  template(slot="empty", v-else) Não há registros.
                  el-table-column(
                    min-width="40"
                  )
                    template(slot-scope="scope")
                      .green
                        i.fal.fa-eye(
                          style="{margin-left: 10px; cursor: pointer;}"
                          @click="goTo(scope.row)",
                          )
                  el-table-column(
                    prop='numeroProcesso',
                    label='Processo',
                    min-width="120"
                  )
                  el-table-column(
                    label='CPF/CNPJ do interessado',
                    min-width='195',
                    prop='cpfCnpjInteressado'
                    :formatter="formatCpfCnpj"
                  )
                  el-table-column(
                    label='Nome/Razão social do interessado',
                    prop='nomeRazaoSocialInteressado'
                    min-width='265',
                    sortable
                  )
                  el-table-column(
                    label='Tipo de processo',
                    prop='tipo.nome',
                    sortable
                    min-width='130'
                  )
                  el-table-column(
                    label='Perfil do Vistoriador',
                    prop='vistoriador',
                    min-width='130'
                  )
                    template(slot-scope="scope")
                      | {{ getNomePerfil(scope.row) }}
                  el-table-column(
                    label='Ações'
                    align="center",
                    align-header="center"
                    width="100%"
                  )
                    template(slot-scope="scope")
                      el-dropdown.botao-acoes(trigger="click", size="small")
                        el-button(v-if="showAcoes(scope.row)", type="primary", size="mini")
                          | Ações
                          i.el-icon-arrow-down.el-icon--right
                        el-button(v-else, type="primary", size="mini", disabled)
                          | Ações
                          i.el-icon-arrow-down.el-icon--right
                        el-dropdown-menu(slot="dropdown")
                          div(v-if="!hasVistoriaFinalizada(scope.row)")
                            div(v-if="scope.row.vistoriador", @click="$emit('alterar', scope.row)")
                              el-dropdown-item
                                i.fas.fa-user
                                | &nbsp Alterar credenciado
                            div(v-else, @click="$emit('vincular', scope.row)")
                              el-dropdown-item
                                i.fas.fa-user
                                | &nbsp Vincular credenciado
                          div(v-else)
                              el-tooltip(
                                class="item"
                                effect="dark"
                                content="Vistoria finalizada"
                                placement="top"
                              )
                                el-dropdown-item.disabled
                                  i.fas.fa-user
                                  | &nbsp Alterar credenciado
                          el-dropdown-item(@click.native="openModalHistorico(scope.row)")
                              i.fas.fa-user
                              | &nbsp Histórico
              slot
              template
                AppModalHistoricoVistoriadores(v-if="openModal && numeroProcesso" :numeroProcesso="numeroProcesso" @closeModal="closeModal")

</template>

<script>
import { mapActions } from 'vuex'
import AppDividerRefreshButton from '@/components/AppDividerRefreshButton'
import AppModalHistoricoVistoriadores from '../components/AppModalHistoricoVistoriadores.vue'

export default {
  components: {
    AppDividerRefreshButton,
    AppModalHistoricoVistoriadores
  },

  props: {
    loading: {
      type: Boolean,
      required: true
    },
    isBusca: {
      type: Boolean,
      default: false
    },
    processos: {
      type: Array,
      required: true
    },
    isCentral: {
      type: Boolean,
      default: true
    },
    headerLabel: {
      type: String,
      default: 'Listagem de processos existentes'
    }
  },

  data () {
    return {
      hasRefreshButton: false,
      tooltipRefreshButton: '',
      openModal: false,
      numeroProcesso: ''
    }
  },

  methods: {
    ...mapActions({
      setLoader: 'loader/setLoader',
      resetLoader: 'loader/resetLoader'
    }),

    checkVazio (row, column, prop) {
      return (prop !== '' && prop) ? prop : '-'
    },

    goTo (data) {
      this.$emit('goTo', data, this.setLoader, this.resetLoader)
    },

    formatCpfCnpj (row, column, prop) {
      if (!prop) {
        return '-'
      }
      if (prop.length === 11) {
        return prop.replace(/^([\d]{3})([\d]{3})([\d]{3})([\d]{2})$/, '$1.$2.$3-$4')
      }
      return prop.replace(/^([\d]{2})([\d]{3})([\d]{3})([\d]{4})([\d]{2})$/, '$1.$2.$3/$4-$5')
    },

    getNomePerfil (row) {
      if (row.vistoriador) {
        return row.vistoriador.credenciadoVistoriador ? 'Credenciado' : 'Técnico ITERPA'
      }
      return '-'
    },

    showAcoes (row) {
      if (row.vistoriador) {
        return (row.tipo.codigo === 'ONEROSO' || row.tipo.codigo === 'NAO_ONEROSO') && row.vistoriador.credenciadoVistoriador
      }
      return row.tipo.codigo === 'ONEROSO' || row.tipo.codigo === 'NAO_ONEROSO'
    },

    closeModal () {
      this.openModal = false
    },

    hasVistoriaFinalizada (row) {
      if (row.subProcessos && row.subProcessos.length > 0) {
        return row.subProcessos.some(sp => sp.funcao === 'VISTORIADOR' &&
        (sp.status === 'FINALIZADO' || sp.status === 'AGUARDANDO_ASSINATURA_LAUDO' || sp.status === 'ASSINADO' || sp.status === 'EM_REVISAO'))
      }
      return false
    },

    openModalHistorico (row) {
      this.numeroProcesso = row.numeroProcesso
      this.openModal = !this.openModal
    },

    sort (data) {
      const ordenacaoFiltro = {
        ordenacao: '',
        tipo: ''
      }

      switch (data.prop) {
        case 'nomeRazaoSocialInteressado':
          ordenacaoFiltro.ordenacao = 'nomeRazaoSocialInteressado'
          break
        case 'tipo.nome':
          ordenacaoFiltro.ordenacao = 'tipo.nome'
          break
        case 'status':
          ordenacaoFiltro.ordenacao = 'status'
          break
        default:
          ordenacaoFiltro.ordenacao = 'dataCadastro'
      }

      if (data.order === 'ascending') {
        ordenacaoFiltro.tipo = 'ASC'
      } else {
        ordenacaoFiltro.tipo = 'DESC'
      }

      this.$emit('sort', { ...ordenacaoFiltro })
    },

    async carregaProcessos () {
      this.$emit('carregaProcessos')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

.titulo {
  color: #424242;
  font-size: 1.5rem;
}
.divider {
  border: 1px solid $border-color;
  margin-bottom: 2px;
}
.marginDivider {
  margin-left: 24px;
  margin-bottom: -25px;
}
.center {
  display: flex;
  align-items: center;
}
.green {
  color: #009f61;
}
.disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
</style>



// WEBPACK FOOTER //
// src/screens/central/credenciados/ListagemProcessosCredenciado.vue